import type { Concert } from './program-schema.ts'

/** Grouping, lookup, and day navigation over the programme snapshot. */

function byStart(a: Concert, b: Concert): number {
  return a.start.localeCompare(b.start) || a.name.localeCompare(b.name, 'nb')
}

export function groupByDay(concerts: readonly Concert[]): Record<string, Concert[]> {
  const grouped: Record<string, Concert[]> = {}
  for (const concert of concerts) {
    ;(grouped[concert.day] ??= []).push(concert)
  }
  for (const day of Object.keys(grouped)) {
    grouped[day]?.sort(byStart)
  }
  return grouped
}

export function concertsForDay(concerts: readonly Concert[], day: string): Concert[] {
  return concerts.filter((c) => c.day === day).sort(byStart)
}

export function findConcert(concerts: readonly Concert[], id: string): Concert | undefined {
  return concerts.find((c) => c.id === id)
}

function step(days: readonly string[], day: string, delta: number): string | null {
  const index = days.indexOf(day)
  if (index === -1) return null
  return days[index + delta] ?? null
}

export function nextDay(days: readonly string[], day: string): string | null {
  return step(days, day, 1)
}

export function previousDay(days: readonly string[], day: string): string | null {
  return step(days, day, -1)
}
